// TODO: fix faq.dev+test@gmail.com

import { Platform } from "react-native";
import config from "~/config";
import { isDesktop } from "~/constants/scale";

// export const validateEmail = (email: string) => {
export const validateEmail = (email: string) => {
    var pattern = new RegExp(
        /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    );
    return pattern.test(email);
};

export const validatePasswordStrength = (password: string): boolean => {
    var regex = new RegExp(/^[0-9a-zA-Z\~\!\@\#\$\%\^\&\*\(\)\-\_\=\+]{6,20}$/);
    if (!regex.test(password)) {
        return false;
    }
    var smallLetters = new RegExp(/[a-z]+/);
    var capitalLetters = new RegExp(/[A-Z]+/);
    var numeric = new RegExp(/[0-9]+/);
    var symbols = new RegExp(/[\~\!\@\#\$\%\^\&\*\(\)\-\_\=\+]+/);
    var hasSmallLetters = smallLetters.test(password);
    var hasCapitalLetters = capitalLetters.test(password);
    var hasNumeric = numeric.test(password);
    var hasSymbols = symbols.test(password);
    var strength: number = 0;
    if (hasSmallLetters) {
        strength = strength + 1;
    }
    if (hasCapitalLetters) {
        strength = strength + 1;
    }
    if (hasNumeric) {
        strength = strength + 1;
    }
    if (hasSymbols) {
        strength = strength + 1;
    }
    if (strength > 1) {
        return true;
    }
    return false;
};

export const isEnableExpectedDailySwap = (dealer: string): boolean => {
    if (dealer === 'EVER' && config.EXPECTED_DAILY_SWAP_DEALER_EVER==='true') return true;
    if (dealer === 'MERIDIAN' && config.EXPECTED_DAILY_SWAP_DEALER_MERIDIAN==='true') return true;
    if (dealer === 'MERIDIAN2' && config.EXPECTED_DAILY_SWAP_DEALER_MERIDIAN2==='true') return true;
    if (dealer === 'MAURITIUS' && config.EXPECTED_DAILY_SWAP_DEALER_MAURITIUS==='true') return true;
    if (dealer === 'NBS' && config.EXPECTED_DAILY_SWAP_DEALER_NBS==='true') return true;
    return false;
}

export const isMeridianDealer = (dealer: string | undefined): boolean =>
    dealer === 'MERIDIAN' || dealer === 'MERIDIAN2';

export const showVerificationCenterForDealer = (dealer: string | undefined): boolean => {
    if (dealer === 'EVER') return true;
    if (dealer === 'MAURITIUS' && config.ENABLE_VERIFICATION_CENTER_MAURITIUS === 'true') return true;
    return false;
}

export const getLegalDocumentsUrl = (dealer: string | undefined): string => {
    if (dealer === 'EVER') {
        return `${config.LEGAL_DOCUMENTS_EVER_URL}`;
    }
    if (dealer === 'MAURITIUS') {
        return `${config.LEGAL_DOCUMENTS_MAURITIUS_URL}`;
    }
    if (dealer === 'MERIDIAN') {
        return `${config.LEGAL_DOCUMENTS_URL}`;
    }
    return `${config.LEGAL_DOCUMENTS_MERIDIAN2}`;
}

export const getPrivacyPolicyUrl = (dealer: string | undefined): string => {
    if (
        config.WEBSITE === 'SANDSTONEFX' ||
        config.WEBSITE === 'PIPS24' ||
        config.WEBSITE === '4EXCLUB' ||
        config.WEBSITE === '24YIELD' ||
        config.WEBSITE === 'INVESTINGFF'
    ) {
        return `${config.PRIVATE_POLICY_APP_URL}`;
    }
    return getLegalDocumentsUrl(dealer);
}

export const isEUCountry = (country: string): boolean => {
    if (country === 'AT') return true;
    if (country === 'BE') return true;
    if (country === 'BG') return true;
    if (country === 'HR') return true;
    if (country === 'CY') return true;
    if (country === 'CZ') return true;
    if (country === 'DK') return true;
    if (country === 'EE') return true;
    if (country === 'FI') return true;
    if (country === 'FR') return true;
    if (country === 'DE') return true;
    if (country === 'GR') return true;
    if (country === 'HU') return true;
    if (country === 'IE') return true;
    if (country === 'IT') return true;
    if (country === 'LV') return true;
    if (country === 'LT') return true;
    if (country === 'LU') return true;
    if (country === 'MT') return true;
    if (country === 'NL') return true;
    if (country === 'PL') return true;
    if (country === 'PT') return true;
    if (country === 'RO') return true;
    if (country === 'SK') return true;
    if (country === 'SI') return true;
    if (country === 'ES') return true;
    if (country === 'SE') return true;
    return false;
}

export const enableRegistrationButton = (): boolean => {
    if (config.WEBSITE === '24YIELD' && !isDesktop()) {
        return false;
    }
    if (config.WEBSITE === 'INVESTINGFF' && !isDesktop()) {
        return false;
    }
    if (config.WEBSITE === 'STEPONEFX') {
        return false;
    }
    return true;
}

export const enableForgotPasswordButton = (): boolean => {
    if (config.WEBSITE === 'STEPONEFX') {
        return false;
    }
    return true;
}

export const parseDateServer = (value: string): Date => {
    if (!value) {
        return null;
    }
    //yyyy-mm-dd
    const parts = value.split("-");
    if (parts.length < 3) {
        return null;
    }
    try {
        const year = parseInt(parts[0]);
        const month = parseInt(parts[1]);
        const day = parseInt(parts[2]);
        const monthIndex = month - 1;
        return new Date(year, monthIndex, day)
    } catch (e) {
        // do nothing
        return null;
    }
};

export const formatDateServer = (value: Date): string => {
    if (!value) {
        return "";
    }
    //yyyy-mm-dd
    const monthIndex = value.getMonth()
    const month = monthIndex + 1;
    return value.getFullYear() + '-' + month + '-' + value.getDate();
};


export const enableCopyTrading = (accountId: number, dealer: string, pt: boolean, registrationDate: number, copyTradingEnabled?: boolean): boolean => {
    if (config.WEBSITE === '4EXCLUB') {
        return false;
    }
    const serverDriven =
        (config.WEBSITE === "SANDSTONEFX" ||
        config.WEBSITE === "PIPS24" ||
        config.WEBSITE === "24YIELD" ||
        config.WEBSITE === "INVESTINGFF") && (dealer === 'MERIDIAN' || dealer === 'MERIDIAN2');
    if (serverDriven) {
        return copyTradingEnabled === true;
    }
    //if(accountId===346665 || accountId===346561 || accountId===346693 || accountId===343915) {
    //    return true;
    //}
    if(accountId==343915) {
        return false;
    }
    if((dealer !== 'EVER' && pt !== true  && config.WEBSITE !== "SANDSTONEFX") && !(config.WEBSITE === "FXMERIDIAN" && dealer==='MERIDIAN' && registrationDate>new Date("2025-11-13").getTime())) {
        return true;
    }
    else {
        return false;
    }
};